import { TGR_BUTTION_LINK_ID } from "../../../common/constants";
import type { ErrorModule, InstallmentDisplay } from "../../../interface";
import { triggerTracking } from "../../../utility/tracking";

interface Input {
  deviceDetails?: any;
  enableApply?: "true" | "false";
}
interface State {
  installmentOffers: Array<InstallmentDisplay>;
  error?: ErrorModule;
  test?: string;
  loading?: boolean;
  amount?: string;
  site?: string;
  currency?: string;
}

export interface Out {}

export default class AppCalculateAction extends Marko.Component<Input, State> {
  onCreate(input: any, out: any) {
    this.state = {
      installmentOffers: out.global.offerResult.data || [],
      loading: false,
      site: out.global.initialState.site || "US",
      amount: out.global.initialState.amount || "0",
      error: out.global.offerResult.error || { name: "", message: "" },
      currency: out.global.initialState.currency || "USD",
    };
    input.deviceDetails = out.global.deviceDetails;
    input.enableApply = out.global.initialState.enableApply;
  }
  async updateCreditOffers(data: any) {
    triggerTracking(TGR_BUTTION_LINK_ID);
    try {
      this.state.loading = true;
      const offerResult = await fetch(
        `/rwdwebui/calculator/table?amount=${data.amount}&currency=${data.currency}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const resdata = await offerResult.json();
      this.state.installmentOffers = resdata.data;
      this.state.error = resdata.error;
      this.state.loading = false;
    } catch (e) {
      this.state.loading = false;
    }
  }
}
